export * from './schedaintense-result.component';
export * from './schedaintense-results.component';